:host {
  display: flex;
  width: 100%;
  gap: calc(var(--pv-size-base) * 4);

  &[aria-expanded="true"] {
    .content {
      white-space: initial;
    }
  }
}

.content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.action {
  flex-shrink: 0;
  margin-top: calc(var(--pv-size-base) * -1);
}
